export default {
  agreement: []
};
